export default {
  agreement: []
};
